
import { Doctor, Staff, Room, ScheduleItem } from './SchedulerTypes';

export interface ScheduleFormData {
  title: string;
  type: 'appointment' | 'admin' | 'break' | 'leave' | 'mc';
  doctorId: string;
  staffId: string;
  roomId: string;
  startTime: string;
  endTime: string;
  notes: string;
  procedure?: string;
  adminTask?: string;
}

export interface ScheduleFormProps {
  doctors: Doctor[];
  staff: Staff[];
  rooms: Room[];
  formData: ScheduleFormData;
  onFormChange: (field: keyof ScheduleFormData, value: string) => void;
}

const addOneHour = (time: string): string => {
  const [hours, minutes] = time.split(':').map(Number);
  const totalMinutes = hours * 60 + minutes + 60;
  const newHours = Math.floor(totalMinutes / 60);
  const newMinutes = totalMinutes % 60;
  const finalHours = Math.min(newHours, 20);
  return `${finalHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
};

export const getInitialFormData = (
  initialData?: ScheduleItem | null,
  defaultStartTime?: string
): ScheduleFormData => {
  if (initialData) {
    return {
      title: initialData.title,
      type: initialData.type,
      doctorId: initialData.doctorId || '',
      staffId: initialData.staffId || '',
      roomId: initialData.roomId || '',
      startTime: initialData.startTime,
      endTime: initialData.endTime,
      notes: initialData.notes || '',
      procedure: initialData.procedure || '',
      adminTask: initialData.adminTask || '',
    };
  }
  
  const startTime = defaultStartTime || '09:00';
  const endTime = addOneHour(startTime);
  
  return {
    title: '',
    type: 'appointment',
    doctorId: '',
    staffId: '',
    roomId: '',
    startTime: startTime,
    endTime: endTime,
    notes: '',
    procedure: '',
    adminTask: '',
  };
};

export const generateTimeOptions = (): string[] => {
  const options = [];
  for (let hour = 8; hour <= 20; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      options.push(time);
    }
  }
  return options;
};
